import { createSelector } from "reselect"
import { getDatesAdjusted as getDatesAdjustedHelper } from "helpers/dates"
import { VIEW_TYPES } from "helpers/base"
import { getViewType } from "."

export const getStartDate = (_, props) => props.startDate
export const getEndDate = (_, props) => props.endDate
export const getLatestDate = (_, props) => props.latestDate
export const getSelectedDate = (_, props) => props.selectedDate
export const getBaseStartDate = (_, props) => props.baseStartDate
const getPeriod = (_, props) => props.period

export const getDatesAdjusted = createSelector(
  [getPeriod, getStartDate, getEndDate, getLatestDate],
  getDatesAdjustedHelper,
)

export const getFetchStartDate = createSelector(
  [getStartDate, getBaseStartDate, getViewType],
  (startDate, baseStartDate, viewType) => {
    if (viewType === VIEW_TYPES.ACTIVE && baseStartDate && startDate < baseStartDate) {
      return baseStartDate
    }

    return startDate
  },
)
